:host {
  --aha-history-list-item--bullet-width: var(--spacer-10);
  --aha-history-list-item--top: var(--spacer-4);
  --aha-history-list-item--bottom: var(--spacer-6);
  --aha-history-list-item--line-width: 1px;
  --aha-history-list-item--line-color: var(--theme-primary-border);
  --aha-history-list-item--bullet-line-visibility: visible;

  display: grid;
  grid-template-columns: var(--aha-history-list-item--bullet-width) auto;
  grid-template-rows: var(--aha-history-list-item--top) auto var(--aha-history-list-item--bottom);
  column-gap: var(--spacer-4);
  position: relative;
}
:host,
:host * {
  box-sizing: border-box;
}
:host(:only-child) {
  --aha-history-list-item--top: 0;
  --aha-history-list-item--bottom: 0;
}
:host(:first-child) {
  --aha-history-list-item--top: 0;
}
:host(:first-of-type:not(:first-child)) {
  /* If it is the fist <aha-history-list-item> element, but is NOT the first child (ex. some other control comes before it), then add extra top padding. */
  --aha-history-list-item--top: var(--spacer-10);
}
:host(:last-child) {
  /* If it is the last <aha-history-list-item> element, then there is no bottom padding. */
  --aha-history-list-item--bottom: 0;
  --aha-history-list-item--bullet-line-visibility: hidden;
}
:host(:last-of-type:not(:last-child)) {
  /* If it is the last <aha-history-list-item> element, then there is no bottom padding. */
  --aha-history-list-item--bottom: var(--spacer-10);
}
:host .line,
:host #bullet {
  display: flex;
  align-items: stretch;
  justify-content: center;
}
:host .line::before {
  content: '';
  background: var(--aha-history-list-item--line-color);
  width: var(--aha-history-list-item--line-width);
}

:host #bullet {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host #bullet-default {
  height: 100%;
}
:host #bullet ::slotted(*) {
  text-align: center;
  margin-bottom: var(--spacer-1);
}
:host #bullet ::slotted(*:first-child) {
  text-align: center;
  margin-top: var(--spacer-1);
}

:host #bullet ::slotted(aha-avatar) {
  width: var(--aha-history-list-item--bullet-width);
  height: var(--aha-history-list-item--bullet-width);
  box-sizing: border-box;
}
:host #bullet-line {
  flex-grow: 1;
  visibility: var(--aha-history-list-item--bullet-line-visibility);
}
:host #content {
  margin-top: var(--spacer-1);
  margin-bottom: var(--spacer-1);
  padding-top: var(--spacer-1);
  padding-bottom: var(--spacer-1);
}
